import { createInjectionState, useMediaControls } from '@vueuse/core'
import { computed, ref } from 'vue'

const [useProvidePreviewVoice, _usePreviewVoice] = createInjectionState((synthesizeFormData) => {
  const audioContent = ref('')
  const audioContentSource = computed(() => `data:audio/wav;base64,${audioContent.value}`)
  const audioRef = computed(() => new Audio(audioContentSource.value))

  const { playing, currentTime, duration } = useMediaControls(audioRef)

  return {
    audioContent,
    audioRef,
    playing,
    currentTime,
    duration,
    synthesizeFormData
  }
})

function usePreviewVoice () {
  const res = _usePreviewVoice()

  if (!res) {
    throw new Error('usePreviewVoice must be used with useProvidePreviewVoice')
  }

  return res
}

export {
  useProvidePreviewVoice,
  usePreviewVoice
}
